var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isIntegratedEntrance)?_c('el-container',[_c('router-view')],1):_c('el-container',[_c('el-header',{staticStyle:{"padding":"0"}},[_c('navigationTop')],1),_c('el-main',[_c('router-view'),_c('navigationButtom')],1),_c('fixedPosition')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }